import { createApi } from '@reduxjs/toolkit/query/react';
import { pensionBaseQuery } from '../../lib/axiosBaseQuery';
import { paramBuilder } from '../../utils/common';

export const custodianApi = createApi({
  reducerPath: 'custodianApi',
  baseQuery: pensionBaseQuery,
  tagTypes: ['Custodians', 'PFCSchedules', 'PFASchedules', 'PaymentItems'],
  endpoints: (builder) => ({
    getSummary: builder.query<any, Record<string, any>>({
      query: (data) => ({
        url: paramBuilder(`api/v1/pension/Custodians/pfc/summary`, {
          ...data,
          StartDate: data.startDate,
          EndDate: data.endDate,
        }),
        method: 'GET',
      }),
      providesTags: ['Custodians'],
    }),
    getPFCSchedules: builder.query<any, Record<string, any>>({
      query: (data) => ({
        url: paramBuilder(`api/v1/pension/Custodians/pfc/schedules`, {
          Page: data.page,
          PageSize: data.pageSize,
          StartTime: data.startDate,
          EndTime: data.endDate,
          searchTerm: data.searchTerm,
          PaymentMethod: data.paymentMethod,
          EmployerCode: data.employerCode,
          transactionId: data.transactionId,
        }),
        method: 'GET',
      }),
      providesTags: ['PFCSchedules'],
    }),
    getPFASchedules: builder.query<any, Record<string, any>>({
      query: (data) => ({
        url: paramBuilder(`api/v1/pension/Custodians/pfa/schedules`, {
          Page: data.page,
          PageSize: data.pageSize,
          StartTime: data.startDate,
          searchTerm: data.searchTerm,
          EndTime: data.endDate,
          PaymentMethod: data.paymentMethod,
          EmployerCode: data.employerCode,
          transactionId: data.transactionId,
        }),
        method: 'GET',
      }),
      providesTags: ['PFASchedules'],
    }),
    getPaymentsItems: builder.query<any, string>({
      query: (id) => ({
        url: `api/v1/pension/Custodians/payment/${id}/items`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'PaymentItems', id }],
    }),
    getOTPOfflinePayments: builder.mutation<any, void>({
      query: () => ({
        url: `api/v1/pension/Custodians/offline/payment/otp`,
        method: 'GET',
      }),
    }),
    confirmOfflinePayment: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/pension/Custodians/offline/payment/confirm`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['PFCSchedules', 'PFASchedules', 'Custodians', 'PaymentItems'],
    }),
    downloadSchedules: builder.mutation<Blob, string[]>({
      query: (paymentItems) => {
        let params = '';
        paymentItems.forEach((element, index) => {
          params += `paymentItems=${element}`;
          if (index !== (paymentItems.length - 1)) {
            params += '&';
          }
        });
        return {
          url: `api/v1/pension/Custodians/download/schedules?${params}`,
          method: 'GET',
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
});

export const {
  useGetSummaryQuery,
  useGetPFCSchedulesQuery,
  useGetPFASchedulesQuery,
  useGetPaymentsItemsQuery,
  useGetOTPOfflinePaymentsMutation,
  useConfirmOfflinePaymentMutation,
  useDownloadSchedulesMutation,
} = custodianApi;
